import React, { useEffect, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import LoadingScreen from '@sharedComponent/app-action-reducer/loading';
import ActionsApp from '@sharedComponent/app-action-reducer/action';
import ActionsLogin from './pages/auth/login/action';
import Selectors from '@sharedComponent/app-action-reducer/selectors';

import 'antd/dist/antd.css';
import './App.css';
import './App.scss';
import './lg.scss';
import './tab.scss';
import './mobile.scss';
import './css/konnektive.scss';

let USER_INACTIVE_TIMEOUT = 4 * 900; //in sec for auto logout. 
let USER_LOGIN_ACTIVE = 600 * 1000; //in milliseconds (sec * 1000 = 5 mins)
let TIMER = '';
let TIMER_LOGIN = '';
let TIME_COUNTER = '';
let timeCounter = 0;
let startCount = false;
function App({ userDetails, removeUser, loginUser }) {
	useEffect(() => {
		resetTimer();
		startTimerLogin();
	}, []);
	const history = useHistory();
	/** Listening for the user interaction with application */
	window.addEventListener('load', () => resetTimer());
	window.addEventListener('mousemove', () => resetTimer());
	window.addEventListener('mousedown', () => resetTimer());
	window.addEventListener('keypress', () => resetTimer());
	window.addEventListener('DOMMouseScroll', () => resetTimer());
	window.addEventListener('mousewheel', () => resetTimer());
	window.addEventListener('touchmove', () => resetTimer());
	window.addEventListener('MSPointerMove', () => resetTimer());

	const startTimer = () => {
		startCount = true;
		// wait 2 seconds before calling goInactive
		// TIMER = setTimeout(goInactive, USER_INACTIVE_TIMEOUT);
	};
	const counterIncrement = () => {
		timeCounter += 1;
		if (timeCounter > USER_INACTIVE_TIMEOUT) {
			goInactive()
		}
	}
	TIME_COUNTER = setInterval(counterIncrement, 2000)
	const resetTimer = () => {
		clearTimeout(TIMER);
		timeCounter = 0;
		startTimer();
	};

	const startTimerLogin = () => {
		TIMER_LOGIN = setInterval(goLogin, USER_LOGIN_ACTIVE);
	}

	const goLogin = () => {
		if (localStorage.getItem('userName')) {
			let loginReq = {
				userName: atob(JSON.parse(localStorage.getItem('userName'))),
				password: atob(JSON.parse(localStorage.getItem('password'))),
				ipAddress: atob(JSON.parse(localStorage.getItem('ipAddress'))),
			}
			loginUser(loginReq, history, true)
		}
	};

	const goInactive = () => {
		if (userDetails && localStorage.getItem('userName')) {
			timeCounter = 0;
			clearTimeout(TIME_COUNTER);
			clearTimeout(TIMER_LOGIN);
			startCount = false;
			removeUser(userDetails.authKey, history);
		}
	};
	return <LoadingScreen />;
}
const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		removeUser: (authKey, history) => dispatch(ActionsApp.creators.removeUser(authKey, history)),
		loginUser: (authKey, history, fromApp) => dispatch(ActionsLogin.creators.login(authKey, history, fromApp)),
	};
};

const RouteWithAuth = withRouter(App);

const Connected = connect(mapStateToProps, mapDispatchToProps)(RouteWithAuth);
export default Connected;
